import fetchRequest from '../util/fetch'
import { notification, errorUtil } from '@app/util'

const query = `mutation PluginUpdate (
    $target: PluginTargetInput!
    $plugin: String!
    $data: PluginInputData!
  ) {
    pluginUpdate (
      target: $target
      plugin: $plugin
      data: $data
    ) {
      id
      plugin
      enabled
      options
    }
}`

async function requestPluginUpdate (variables, token) {
  const response = await fetchRequest({
    variables,
    query,
    token
  })
  if (!response) return errorUtil.noResponse()

  const { errors, data } = response
  if (errors) {
    return errorUtil.apiError('plugin-update', errors)
  }
  notification.success({ code: 'success' })
  return data.pluginUpdate
}

export default requestPluginUpdate
